import { alpha, IconButton, styled } from '@mui/material';

interface StyledToggleButtonProps {
  isCollapsed: boolean;
}

const StyledToggleButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'isCollapsed',
})<StyledToggleButtonProps>(({ theme, isCollapsed }) => ({
  position: 'fixed',
  top: 24,
  zIndex: 1201,
  left: isCollapsed ? 60 : 275, // keeps the button over the border of the navigation.
  transform: 'translateX(-50%)',
  width: 32,
  height: 32,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
  boxShadow: theme.shadows[2],
  transition: theme.transitions.create(['left'], {
    easing: 'linear',
    duration: 120,
  }),
  '&:hover': {
    backgroundColor: '#F6F7F8',
  },
}));

export default StyledToggleButton;
